import { Box } from '@mui/material';
import React from 'react';
import { ChevronRight } from '@mui/icons-material';

import { BackButton } from 'components/BackButton/BackButton';
import { gray5, grayish } from 'utils/color-styles';

export const Breadcrumbs = ({ send, title }: { send: (action: string) => void; title: string }) => (
  <Box display="flex" alignItems="center" pt={2} mt={3}>
    <BackButton size={40} color={gray5} onClick={() => send('PREV')} />
    <Box onClick={() => send('PREV')} color={grayish} mx={2} style={{ cursor: 'pointer' }}>
      Claim your profile
    </Box>
    <ChevronRight style={{ color: grayish }} />
    <Box mx={2}>{title}</Box>
  </Box>
);
